import { render, staticRenderFns } from "./StatusSubscriptionsModal.vue?vue&type=template&id=197144e0&scoped=true&"
import script from "./StatusSubscriptionsModal.vue?vue&type=script&lang=js&"
export * from "./StatusSubscriptionsModal.vue?vue&type=script&lang=js&"
import style0 from "./StatusSubscriptionsModal.vue?vue&type=style&index=0&id=197144e0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197144e0",
  null
  
)

export default component.exports